// SetningsMinne/TrialSentences.js
import React, {Component} from 'react';
import strings from 'strings';
import {updateStepData} from 'api';
import listen from 'assets/listen.png';
import {stopAllSounds, createHowl, playHowl} from 'utils/playSound';

// Audio asset packs you provide (Howler or HTMLAudio wrappers).
// Each should index steps: 0,1,2,... and have .play(), .pause()/stop(), .on('end', cb)
import {getTrialAudioPack, getTrialFeedbackPack} from './assets';

import './styles.scss';

class TrialSentences extends Component {
	constructor(props) {
		super(props);
		const langCode = strings.getLanguage();
		this.assets = getTrialAudioPack(
			langCode,
			props.ageGroup,
			props.testKeyType
		);
		this.answers = getTrialFeedbackPack(
			langCode,
			props.ageGroup,
			props.testKeyType
		);
	}

	componentDidMount() {
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopAll();
		clearTimeout(this.timeout);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.currentStep !== this.props.currentStep) {
			this.startNewTask(this.props.currentStep);
		}
		const prevSD = prevProps.stepData || {};
		const nextSD = this.props.stepData || {};
		if (nextSD.answered && !prevSD.answered) {
			this.playFeedback(this.props.currentStep, nextSD.correct);
		}
	}

	initializeAudio = () => {
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			600
		);
	};

	startNewTask = (idx) => {
		stopAllSounds();

		const src = this.assets[idx];
		if (!src) {
			console.warn('Missing audio for trial step', idx);
			return;
		}

		const sound = createHowl({
			src,
			onend: () => {
				sound.unload(); // prevent memory leak
			},
		});

		playHowl(sound);
	};

	playFeedback = (taskIndex, isCorrect) => {
		stopAllSounds();

		const n = (taskIndex || 0) + 1;
		const key = `${isCorrect ? 'correct' : 'incorrect'}${n}`;
		let src = this.answers[key];

		if (!src) {
			src = this.answers[isCorrect ? 'correct' : 'incorrect'];
			if (!src) {
				setTimeout(() => updateStepData({feedbackDone: true}), 800);
				return;
			}
		}

		const sound = createHowl({
			src,
			onend: () => {
				sound.unload(); // prevent memory leak

				setTimeout(() => {
					updateStepData({feedbackDone: true});
				}, 400);
			},
		});

		playHowl(sound);
	};

	stopAll = () => {
		stopAllSounds();
	};

	render() {
		return (
			<div className="SetningsMinne">
				<img className="listen-image" src={listen} alt="" />
			</div>
		);
	}
}

export default TrialSentences;
